export const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "null");
  } catch {
    return null;
  }
};

export const readAllowed = () => {
  try {
    const raw = localStorage.getItem("allowedPermission");
    const arr = raw ? JSON.parse(raw) : [];
    if (Array.isArray(arr)) return arr;
  } catch {}
  const u = readUser();
  return u?.rolename?.rolePermission || [];
};

// allowedPermission row shape: { pagename, permission: ["View","Create",...] }
export const can = (pageName, action = "View") => {
  if (!pageName) return false;
  // MASTER can do everything
  const role = readUser()?.rolename?.roleName;
  if (role === "MASTER") return true;

  const allowed = readAllowed();
  const row = allowed.find((r) => (r?.pagename || r?.title) === pageName) || {};
  const list = Array.isArray(row.permission) ? row.permission : [];
  return list.includes(action);
};

// legacy shim for your existing helper
export const CheckPermission = (pageName) => ({
  View: can(pageName, "View"),
  Create: can(pageName, "Create"),
  Edit: can(pageName, "Edit"),
  Delete: can(pageName, "Delete"),
  Download: can(pageName, "Download"),
  BulkUpload: can(pageName, "BulkUpload"),
});
